import { ChevronLeft, ChevronRight, MoreHorizontal, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { type ButtonVariants } from '@/components/ui/button-variants';
import { cn } from '@/helpers/shadcn';
import { type ButtonHTMLAttributes } from 'react';

// Define accepted icons
export const IconButtonIcons = {
  ChevronLeft,
  ChevronRight,
  MoreHorizontal,
  X,
} as const;

export type IconButtonIcon = keyof typeof IconButtonIcons;

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: IconButtonIcon;
  sizeVariant?: 'small' | 'large';
  buttonVariant?: ButtonVariants['variant'];
}

export function IconButton({
  icon,
  sizeVariant = 'small',
  buttonVariant,
  className,
  ...props
}: IconButtonProps) {
  const IconComponent = IconButtonIcons[icon];

  if (sizeVariant === 'large') {
    return (
      <Button
        variant={buttonVariant}
        className={cn('h-12 w-12 rounded-full', className)}
        {...props}
      >
        <IconComponent className="h-6 w-6" />
      </Button>
    );
  }

  // Small sizeVariant (default)
  return (
    <Button
      variant={buttonVariant}
      size="icon"
      className={cn('rounded-full', className)}
      {...props}
    >
      <IconComponent className="h-5 w-5" />
    </Button>
  );
}
